module.exports = __webpack_public_path__ + "static/media/5.eaa1804a.jpg";